module.exports = __webpack_public_path__ + "static/media/the-game-afl-2025-v2.bcc7de94.png";